"use client";

import type * as React from "react";
import { useEffect } from "react";

import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks";
import {
  fetchMasterData,
  selectMasterDataStatus,
} from "@/lib/redux/features/master-data/masterDataSlice";

type MasterDataInitializerProps = {
  children: React.ReactNode;
};

export const MasterDataInitializer: React.FC<MasterDataInitializerProps> = ({
  children,
}) => {
  const dispatch = useAppDispatch();
  const status = useAppSelector(selectMasterDataStatus);

  useEffect(() => {
    if (status === "idle") {
      void dispatch(fetchMasterData());
    }
  }, [dispatch, status]);

  return children;
};
